module.exports = __webpack_public_path__ + "static/media/2-2.75430eb5.png";